import { useState, createContext, useContext } from "react";

type ShowPickersProviderProps = {
  children?: React.ReactNode;
};

const ShowPickersContext = createContext<any>(null);

export function ShowPickersProvider({ children }: ShowPickersProviderProps) {
  const [openStartDate, setOpenStartDate] = useState(false);
  const [openStartTime, setOpenStartTime] = useState(false);
  const [openEndTime, setOpenEndTime] = useState(false);
  const [openEndDate, setOpenEndDate] = useState(false);

  return (
    <ShowPickersContext.Provider
      value={{
        openStartDate,
        setOpenStartDate,
        openStartTime,
        setOpenStartTime,
        openEndTime,
        setOpenEndTime,
        openEndDate,
        setOpenEndDate,
      }}
    >
      {children}
    </ShowPickersContext.Provider>
  );
}

export default function useShowPickers() {
  const context = useContext(ShowPickersContext);
  if (!context) {
    throw new Error(`useShowPickers must be used within a ShowPickersContext`);
  }

  const {
    openStartDate,
    setOpenStartDate,
    openStartTime,
    setOpenStartTime,
    openEndTime,
    setOpenEndTime,
    openEndDate,
    setOpenEndDate,
  } = context;

  return {
    openStartDate,
    setOpenStartDate,
    openStartTime,
    setOpenStartTime,
    openEndTime,
    setOpenEndTime,
    openEndDate,
    setOpenEndDate,
  };
}
